export default "__VITE_ASSET__DRMMr_38__"